import { getClaimKey } from '../functions/get-claim-key';
import {
  CsvExport,
  ExcelExport,
  ExcelSheet,
} from '../models/api/core/export/export';

export class DiaryExportMapper {
  static toCsvExport(rows: any[], columns: any[], fileName: string): CsvExport {
    const headers = columns.map(this.getlabel);
    const dataRows = rows.map((row) =>
      columns.map((col) => this.getColumnValue(row, col.name)),
    );

    return {
      fileName,
      headers,
      rows: dataRows,
    };
  }

  static toExcelExport(
    rows: any[],
    columns: any[],
    fileName: string,
    sheetLabel: string,
  ): ExcelExport {
    const headers = columns.map(this.getlabel);
    const dataRows = rows.map((row) =>
      columns.map((col) => this.getColumnValue(row, col.name)),
    );

    const sheet: ExcelSheet = {
      label: sheetLabel,
      headers,
      rows: dataRows,
    };

    return {
      fileName,
      sheets: [sheet],
    };
  }

  private static getlabel(column: any): string {
    const source = getClaimKey().recordSource;
    let headerMappings: Record<string, string>;
    if (source === 'J') {
      headerMappings = {
        dueDate: 'Due Date',
        examiner: 'Examiner',
        type: 'Diary Type',
        claim: 'Claim',
        dateCreated: 'Created Date',
        dateCompleted: 'Completed Date',
        completedBy: 'Completed By',
        priority: 'Priority',
        text: 'Diary Text',
      };
    } else if (source === 'T' || source === 'L') {
      headerMappings = {
        dateCreated: 'Created Date',
        examiner: 'Examiner',
        type: 'Diary Type',
        text: 'Diary Text',
      };
    } else {
      headerMappings = {
        dueDate: 'Due Date',
        examiner: 'Examiner',
        type: 'Diary Type',
        claim: 'Claim',
        text: 'Diary Text',
      };
    }

    return headerMappings[column.name] || column.label || column.name;
  }

  private static getColumnValue(row: any, name: string): any {
    if (!row || !name) return undefined;

    const keys = Object.keys(row);
    const lowerKeyMap = keys.reduce(
      (acc, key) => {
        acc[key.toLowerCase()] = key;
        return acc;
      },
      {} as Record<string, string>,
    );

    if (name.toLowerCase() === 'claim') {
      const claimKey = lowerKeyMap['claim'];
      return claimKey ? row[claimKey] : undefined;
    }

    if (name.toLowerCase() === 'filenumber') {
      const fileKey = lowerKeyMap['filenumber'];
      return fileKey ? row[fileKey] : undefined;
    }

    const actualKey = lowerKeyMap[name.toLowerCase()];
    return actualKey ? row[actualKey] : undefined;
  }
}
